import {CommonNs} from '@shared/types/common.namespace';
import {WorkspaceNs} from "@shared/types/workspace.namespace";
import {IntegrationNs} from "@shared/types/integration.namespace";
import {AccountNs} from "@shared/types/account.namespace";

export namespace SettingNs {

    export enum SettingRouteEnums {
        SETTINGS = 'Settings',
        THEMES = 'SettingThemes',
        NOTIFICATIONS = 'SettingNotifications',
        COMPANY = 'SettingCompany',
        MEMBERS = 'SettingMembers',
        MEMBERSPAGE = 'SettingMembersPage',
        MEMBERDETAILS = 'SettingMemberDetails',
        SUGGESTEMAIL = 'SettingSuggestEmail',
        INVITETEAMMEMBERS = 'SettingInviteTeamMembers',
        CUSTOMIZE = 'SettingCustomize',
        INTEGRATIONS = 'SettingIntegrations',
        INTEGRATIONSPAGE = 'SettingIntegrationsPage',
        INTEGRATIONS_DETAIL = 'SettingIntegrationsDetail',
        CREDITS = 'SettingCredits',
        BILLING = 'SettingBilling',
        BILLINGADDRESS = 'SettingBillingAddress',
        PAYMENTMETHOD = 'SettingPaymentMethod',
        UPGRADE = 'SettingUpgrade',
    }

    export interface CompanyProperty {
        name: string,
        label: string,
        type: string,
        isCustom: boolean,
        inputValue: any,
        permission: CommonNs.PermissionsEnums,
        icon: string,
        iconType: string,
    }

    export interface CompanyInfo {
        id: string,
        company: CompanyProperty,
        companyEmail: CompanyProperty,
        companyProperties?: CompanyProperty[],
        companyImage: string,
        companyImageCover: string,
    }

    export interface CompanyInfoRequest {
        workspaceId: string,
    }

    export interface UpdateCompanyInfoRequest {
        workspaceId: string,
        companyProperties?: AccountNs.AccountProperty[],
    }

    export interface SettingsState {
        companyInfo: CompanyInfo,
        workspaceMembers: WorkspaceNs.Member[],
        selectedMember: WorkspaceNs.Member,
        workspaceIntegrations: IntegrationNs.IntegrationInfo[],
        integrationDetailInfo: IntegrationNs.IntegrationInfo,
        projectIntegration: IntegrationNs.ProjectIntegrationInfo,
    }

    export interface UpdateMemberInfoRequest {
        workspaceId: string,
        memberId: number,
        fullName: string,
        primaryEmail: string,
        position: string,
    }
}
